import { Inject, Injectable } from '@angular/core';
import { SessionNamespace } from './session-namespace.class';

@Injectable()
export class SessionStorageService {
    /**
     * Namespaces map
     */
    // tslint:disable-next-line:variable-name
    private readonly _namespaces: Map<string, SessionNamespace<any>> = new Map(
        []
    );

    /**
     * Service class constructor
     *
     * Populate the Namespaces Map based on any namespace storage entry
     */
    public constructor(@Inject('StorageNamespace') private key: string) {
        const pattern = new RegExp(`(${this.key}:)`, 'g');

        // tslint:disable-next-line:no-shadowed-variable
        Object.keys(localStorage).forEach((key) => {
            if (key.match(pattern)) {
                this._namespaces.set(key, new SessionNamespace<any>(key));
            }
        });

        window.addEventListener('storage', (event) => {
            if (this._namespaces.has(this.key)) {
                const attribute = this._namespaces.get(this.key);
                if (attribute) {
                    attribute.touch(event.newValue);
                }
            }
        });
    }

    /**
     * Return an object reference to the specified namespace
     */
    public namespace(name: string): SessionNamespace<any> {
        const key = `${this.key}:${name}`;
        let ns = this._namespaces.get(key);

        if (!ns) {
            ns = new SessionNamespace<any>(key);
            this._namespaces.set(key, ns);
        }

        return ns;
    }

    /**
     * Remove all storage namespaces entries
     */
    public clear(): void {
        const pattern = new RegExp(`(${this.key}:)`, 'g');

        Object.keys(sessionStorage).forEach((key) => {
            if (key.match(pattern)) {
                sessionStorage.removeItem(key);
            }
        });
        this._namespaces.clear();
    }

    /**
     * Apply the specified function to each namespace
     */
    public forEachNS(fnc: (ns: any, idx: any) => void): void {
        this._namespaces.forEach(fnc);
    }
}
